import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Card, Col, Form, Popover, Row, Select, Space, Spin, Switch, Tag, Tooltip, Typography } from 'antd';
import { useState, useEffect } from 'react';
import commonService from '../../services/CommonService';
import { getCertificateExpireCountsChartData, getCertificateRenewalCountsChartData, getJsonDataForSubProjects, getTotalCount } from '../../utils/chartCalculations';
import { Line } from '@ant-design/plots/es/';
import { FilterOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import RenewalDecisionTable from './RenewalDecisionTable';
import { setWoBrandNames, setWoCountry, setWoModelNames } from '../../context/reducers/userReducer';
import { UserActivity } from "../../config/BVConstants";
export const WaveChart = ({ flag }) => {
    const [data, setData] = useState([]);
    const [brandData, setBrandData] = useState([]);
    const [modalData, setModalData] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [selectedModal, setSelectedModal] = useState();
    const [selectedCountry, setSelectedCountry] = useState();
    const [totalCount, setTotalCount] = useState(0);
    const [startCount, setStartCount] = useState(0);
    const [endCount, setEndCount] = useState(0);
    const applicationData = useSelector((state) => state.applicationData); //useApplicationContext();
    const [clientId, setClientId] = useState(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList);
    const [isLoading, setIsLoading] = useState(false);
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isFilterLoading, setIsFilterLoading] = useState(false);
    const [result, setResult] = useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        if (flag === 1) {
            commonService.getWoBrandNames(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList).then((res) => {
                dispatch(setWoBrandNames(res));
            });
            commonService.getWoModelNames(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList).then((res) => {
                dispatch(setWoModelNames(res));
            });
            commonService.getWoCountry(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList).then((res) => {
                dispatch(setWoCountry(res));
            });
        }
        else {
            commonService.getCountryCertProjects(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList).then((res) => {
                dispatch(setWoCountry(res));
            });
            commonService.getBrandNamesCertProjects(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList).then((res) => {
                dispatch(setWoBrandNames(res));
            });
            commonService.getModelNamesCertProjects(applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList).then((res) => {
                dispatch(setWoModelNames(res));
            });
        }
    }, [applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList]);
    useEffect(() => {
        setIsLoading(true);
        if (flag === 1) {
            setModalData(applicationData === null || applicationData === void 0 ? void 0 : applicationData.woModelNames);
            setBrandData(applicationData === null || applicationData === void 0 ? void 0 : applicationData.woBrandNames);
            setCountryData(applicationData === null || applicationData === void 0 ? void 0 : applicationData.woCountry);
            commonService
                .getSubProjectCounts(subProjectReqJson(clientId, null, null, null))
                .then((result) => {
                setData(getJsonDataForSubProjects(result));
                setTotalCount(getTotalCount(result, 1, 0));
                setStartCount(getTotalCount(result, 1, 1));
                setEndCount(getTotalCount(result, 1, 2));
                setIsLoading(false);
            });
        }
        if (flag === 2 || flag === 3) {
            if (applicationData === null || applicationData === void 0 ? void 0 : applicationData.countryCertProjects)
                setCountryData(applicationData === null || applicationData === void 0 ? void 0 : applicationData.countryCertProjects);
            if (applicationData === null || applicationData === void 0 ? void 0 : applicationData.brandNamesCertProjects)
                setBrandData(applicationData === null || applicationData === void 0 ? void 0 : applicationData.brandNamesCertProjects);
            if (applicationData === null || applicationData === void 0 ? void 0 : applicationData.modelNamesCertProjects)
                setModalData(applicationData === null || applicationData === void 0 ? void 0 : applicationData.modelNamesCertProjects);
            if (flag === 2) {
                commonService
                    .getCertificateRenewalCounts(subProjectReqJson(clientId, null, null, null))
                    .then((result) => {
                    var _a, _b;
                    setResult(result);
                    setData(getCertificateRenewalCountsChartData(result));
                    setTotalCount(getTotalCount(result, 2, 0));
                    setStartCount(getTotalCount(result, 2, 1));
                    setEndCount(getTotalCount(result, 2, 2));
                    setIsLoading(false);
                    commonService
                        .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Dashboard_CM_Decision_Search);
                });
            }
            if (flag === 3) {
                commonService
                    .getCertificateExpiryCounts(subProjectReqJson(clientId, null, null, null))
                    .then((result) => {
                    var _a, _b;
                    setResult(result);
                    setData(getCertificateExpireCountsChartData(result));
                    setTotalCount(getTotalCount(result, 3, 0));
                    setStartCount(getTotalCount(result, 3, 1));
                    setEndCount(getTotalCount(result, 3, 2));
                    setIsLoading(false);
                    commonService
                        .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Dashboard_CM_Expiration_Search);
                });
            }
        }
    }, [clientId]);
    useEffect(() => {
        setIsLoading(true);
        if (flag === 1) {
            commonService
                .getSubProjectCounts(subProjectReqJson(clientId, selectedBrand, selectedModal, selectedCountry))
                .then((result) => {
                setData(getJsonDataForSubProjects(result));
                setTotalCount(getTotalCount(result, 1, 0));
                setStartCount(getTotalCount(result, 1, 1));
                setEndCount(getTotalCount(result, 1, 2));
                setIsLoading(false);
            });
        }
        if (flag === 2) {
            commonService
                .getCertificateRenewalCounts(subProjectReqJson(clientId, selectedBrand, selectedModal, selectedCountry))
                .then((result) => {
                var _a, _b;
                setResult(result);
                setData(getCertificateRenewalCountsChartData(result));
                setTotalCount(getTotalCount(result, 2, 0));
                setStartCount(getTotalCount(result, 2, 1));
                setEndCount(getTotalCount(result, 2, 2));
                setIsLoading(false);
                commonService
                    .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Dashboard_CM_Decision_Search);
            });
        }
        if (flag === 3) {
            commonService
                .getCertificateExpiryCounts(subProjectReqJson(clientId, selectedBrand, selectedModal, selectedCountry))
                .then((result) => {
                var _a, _b;
                setResult(result);
                setData(getCertificateExpireCountsChartData(result));
                setTotalCount(getTotalCount(result, 3, 0));
                setStartCount(getTotalCount(result, 3, 1));
                setEndCount(getTotalCount(result, 3, 2));
                setIsLoading(false);
                commonService
                    .logUserActivity((_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId, UserActivity.CP__Dashboard_CM_Expiration_Search);
            });
        }
    }, [isFilterLoading]);
    const config = {
        data,
        xField: 'date',
        yField: 'value',
        colorField: 'type',
        axis: {
            y: {
                labelFormatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`)
            }
        },
        scale: { color: { range: ['#30BF78', '#F4664A', '#FAAD14'] } },
        style: {
            lineWidth: 4,
            lineDash: (data) => {
                if (data[0].type === 'register')
                    return [4, 4];
            },
            opacity: (data) => {
                if (data[0].type !== 'register')
                    return 0.5;
            }
        }
    };
    const handleApply = () => {
        setIsFilterLoading(!isFilterLoading);
        setPopoverVisible(false);
    };
    const popoverContent = (_jsxs(Form, { children: ["Brand:", _jsx(Form.Item, { style: { margin: '0px' }, children: _jsxs(Select, { defaultValue: "Brand", onChange: (value) => setSelectedBrand({ intId: parseInt(value) }), style: { width: '100%' }, showSearch: true, optionFilterProp: "children", children: [_jsx(Select.Option, { value: 0, children: "All" }), brandData.map((brand) => (_jsx(Select.Option, { value: brand.intId, children: brand.strLongDesc }, brand.intId)))] }) }), "Product Model:", _jsx(Form.Item, { style: { margin: '0px' }, children: _jsxs(Select, { defaultValue: "Product Model", onChange: (value) => setSelectedModal(value), style: { width: '100%' }, showSearch: true, optionFilterProp: "children", children: [_jsx(Select.Option, { value: "", children: "All" }), modalData.map((modal, index) => (_jsx(Select.Option, { value: modal, children: modal }, index)))] }) }), "Country:", _jsx(Form.Item, { children: _jsxs(Select, { defaultValue: "Country", onChange: (value) => setSelectedCountry(value ? { intId: Number(value) } : undefined), style: { width: '100%' }, showSearch: true, optionFilterProp: "children", children: [_jsx(Select.Option, { value: 0, children: "All" }), countryData.map((country) => (_jsx(Select.Option, { value: country.intId, children: country.strLongDesc }, country.intId)))] }) }), _jsx(Form.Item, { style: { margin: '0px', textAlign: 'end' }, children: _jsx(Button, { onClick: handleApply, htmlType: "submit", type: "primary", children: "Apply" }) })] }));
    const filterControls = (_jsx(Popover, { content: popoverContent, trigger: "click", open: popoverVisible, onOpenChange: setPopoverVisible, getPopupContainer: (trigger) => document.body, placement: "bottomRight", style: { zIndex: 900, width: '20%' }, children: _jsx(FilterOutlined, {}) }));
    const [isTableView, setIsTableView] = useState(false); // State to track the toggle button
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        // Fetch and set table data (example using `data`)
        if (isTableView) {
            setTableData(data.map((item, index) => (Object.assign({ key: index }, item))));
        }
    }, [isTableView, data]);
    return (_jsx(Card, { title: flag == 1
            ? 'Sub Projects'
            : flag == 2
                ? 'Decision Date (Certificate)'
                : 'Expiration Date (Certificate)', className: "dashboard-card", size: "small", extra: _jsxs(_Fragment, { children: [_jsx(Tooltip, { title: isTableView ? 'Show Chart View' : 'Show Table View', children: _jsx(Switch, { size: "small", style: { marginRight: '11px', marginTop: '-2px' }, checked: isTableView, onChange: (checked) => setIsTableView(checked) }) }), filterControls] }), children: _jsx(Row, { children: _jsx(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, children: _jsxs(Space, { size: 'small', direction: "vertical", style: { width: '-webkit-fill-available', textAlign: 'center' }, children: [_jsx("div", { style: { height: isTableView ? '328px' : '322px' }, children: isLoading ? (_jsx("div", { style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '300px'
                                }, children: _jsx(Spin, { size: "small" }) })) : isTableView ? (_jsx(RenewalDecisionTable, { data: data, flag: flag, brand: selectedBrand, model: selectedModal, country: selectedCountry, result: result })) : (_jsx(Line, Object.assign({}, config))) }), _jsxs(Space, { children: [_jsx(Tag, { color: "red", children: `Total: ${totalCount}` }), _jsx(Tag, { color: "green", children: `${flag === 1 ? 'Started' : 'Undecided'}: ${startCount}` }), _jsx(Tag, { color: "yellow", children: `${flag === 1 ? 'Not Started' : 'Decided'}: ${endCount}` })] }), _jsxs(Typography.Text, { style: { fontSize: '10px' }, children: [flag == 1 && _jsx(_Fragment, { children: "Note: Completed Sub Projects are not shown in this chart" }), flag == 2 && (_jsxs(_Fragment, { children: ["Note: This chart reflects the", ' ', _jsx(Tooltip, { title: "Recommended Decision Date is an automatically calculated date. It comes from taking the total elapsed time (including quotation management, order processing, document preparation, in-country/territory testing (if applicable), certificate processing and issuance, ...) away from the certificate expiry date. The end result is the provision of an advance renewal notice to help customers verify their certificates remain in compliance.", style: { backgroundColor: 'white', color: 'black' }, children: _jsx("span", { style: {
                                                    color: 'blue',
                                                    textDecoration: 'underline',
                                                    cursor: 'pointer',
                                                }, children: "recommended decision date" }) }), ", not certificate expiry date."] })), flag == 3 && _jsx(_Fragment, { children: "Note: This chart reflects the expiry date not the renewal date." })] })] }) }) }) }));
};
function subProjectReqJson(clientId, selectedBrand, selectedmodal, selectedCountry) {
    return {
        lstLuCompany: clientId,
        lstCountries: selectedCountry == null ? null : [selectedCountry],
        objLuBrandName: selectedBrand,
        strModelName: selectedmodal,
        intCertStatus: 1806
    };
}
